// extracted by mini-css-extract-plugin
export var avatar = "index-module--avatar--1TOdV";
export var bodyText = "index-module--body-text--3GuYM";